/* eslint-disable no-console */
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

import ReportHeader from './ReportHeader';
import Workspace from '../../models/Workspace';
import { megaBytesToBytes } from '../../utils/files';
import EditFields from '../common/EditFields';

export const Colors = [{ value: '#388E3C' }, { value: '#2AAAE2' }, { value: '#C2185B' }, { value: '#F19100' }, { value: '#787FF6' }, { value: '#0D5CB8' }, { value: '#636363' }];

const useStyles = makeStyles(() => ({
  globalIntroduction: {
    color: '#999999',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '23px',
    minHeight: '80px',
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    width: '100%',
  },
  mainSettings: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    paddingLeft: '2rem',
    paddingTop: '2rem',
  },
}));

const EditWorkspace = ({ role, validationErrors, onSubmit, workspace, onChangeIntroduction }) => {
  const [errors, setErrors] = useState(validationErrors);
  const [userWorkspace, setWorkspace] = useState(workspace);

  const classes = useStyles();
  const fieldsRef = useRef();

  useEffect(() => {
    setErrors(validationErrors);
  }, [validationErrors]);

  const isSuperAdmin = role === 'super-admin';
  const canEditHeader = isSuperAdmin || role === 'admin';

  useEffect(() => {
    setWorkspace(workspace);
  }, [workspace]);

  const fields = useMemo(
    () => [
      {
        errorMessage: 'File must not be bigger than 2MB.',
        label: 'Workspace Logo',
        message: 'Max height: 52px (recommended) . Max size allowed: 2MB',
        name: 'logoUrl',
        type: 'image-upload',
        validation: (file) => file?.size < megaBytesToBytes(2),
      },
      { items: Colors, label: 'Workspace Primary colour', name: 'primaryColor', required: true, type: 'color-select' },
    ],
    []
  );

  const handleSubmit = () => {
    const validData = fieldsRef.current.getValidData();

    if (validData) {
      onSubmit(validData);
    }
  };

  return (
    <Container style={{ marginTop: '6.5rem', textAlign: 'left' }}>
      <Grid container>
        <Grid item xs={12} container className="mb-2">
          <Grid item xs={4}>
            <Typography variant="h4" className="page-header" align="left">
              Settings
            </Typography>

            <Typography variant="body1" className="body-copy mt-1" align="left" style={{ width: '450px' }}>
              Change the visual appearance of your workspace {isSuperAdmin && 'and global video settings'}. Do note that workspace changes will reflect on your next login.
            </Typography>
          </Grid>
        </Grid>

        <Grid item container xs={12} justify="center">
          <Grid item xs={4}>
            <div className="right-separator pr-3 pb-2 pt-2">
              <Typography className="secondary-header">My Workspace</Typography>

              <EditFields
                validationErrors={errors}
                ref={fieldsRef}
                fields={fields}
                labelPosition="top"
                labelClass="mb-1"
                validate={Workspace.validateCreate}
                data={userWorkspace}
              />

              <Button variant="contained" color="primary" onClick={handleSubmit} className="mt-1">
                Apply Changes
              </Button>
            </div>
          </Grid>

          <Grid item xs={8} className={classes.mainSettings}>
            {isSuperAdmin && (
              <Grid container>
                <Typography className="secondary-header mb-1">Global video introduction</Typography>
                <Typography className={classes.globalIntroduction}>{workspace?.globalVideoIntroduction}</Typography>
                <Button variant="contained" color="primary" onClick={onChangeIntroduction} style={{ marginTop: '8px' }}>
                  Change introduction
                </Button>
              </Grid>
            )}

            {canEditHeader && <ReportHeader workspace={workspace} />}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EditWorkspace;
